import _ from "lodash";

import { AddIcon, EditIcon } from "icons";
import theme from "theme";
import { colors } from "theme/palette";

import { DialogTitle } from "components/Dialog";
import Stack from "components/Stack";
import Text from "components/Text";

export interface ITransactionTypeSpecificHeader {
  transactionType: string;
  lastUpdatedInformation: string | null;
  transactionIdentifier?: string;
}

const TransactionTypeSpecificHeader = ({
  transactionType,
  transactionIdentifier,
  lastUpdatedInformation,
}: ITransactionTypeSpecificHeader) => (
  <>
    <DialogTitle
      sx={{
        margin: theme.spacing(2, 2, 0, 2),
        padding: 2,
        borderRadius: theme.spacing(1),
        backgroundColor: colors.blue10,
      }}
    >
      {!_.isNil(transactionIdentifier) ? (
        <>
          <Text
            variant="text4"
            sx={{
              fontSize: 10,
              fontWeight: 500,
              color: colors.blue100,
              letterSpacing: 0.3,
            }}
          >
            TRANSACTION
          </Text>
          <Text variant="h2">{transactionIdentifier}</Text>
          <Text variant="text4" color={colors.gray60}>
            {lastUpdatedInformation}
          </Text>
        </>
      ) : (
        <Stack direction="row" alignItems="center" spacing={1}>
          <AddIcon
            style={{
              height: "35px",
              width: "35px",
            }}
          />
          <Text variant="h2">New transaction</Text>
        </Stack>
      )}
    </DialogTitle>
    <DialogTitle
      sx={{
        margin: theme.spacing(2, 2, 0, 2),
        padding: 2,
        borderRadius: theme.spacing(1),
        backgroundColor: colors.blue60,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <EditIcon
          style={{
            height: "35px",
            width: "35px",
          }}
        />
        <Text variant="h2">
          {!_.isNil(transactionIdentifier)
            ? "Edit specific details"
            : "Specific details"}
        </Text>
        <Text
          padding={1}
          maxWidth="fit-content"
          border={1}
          borderColor={colors.gray20}
          sx={{ backgroundColor: colors.white }}
          borderRadius={1}
        >
          {transactionType}
        </Text>
      </Stack>
    </DialogTitle>
  </>
);

export default TransactionTypeSpecificHeader;
